import script from "./AssignCustomersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignCustomersModal.vue?vue&type=script&setup=true&lang=js"

import "./AssignCustomersModal.vue?vue&type=style&index=0&id=233bc57d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233bc57d"]])

export default __exports__